import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    borderBottom: 'none !important',
    fontSize: 12
  }
}))(TableCell);

const useStyles = makeStyles(() => ({
  input: {
    color: '#002380',
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  percentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& span': {
      marginLeft: 2,
      color: '#002380',
      fontWeight: 600
    }
  }
}));

const InputControlled = ({
  value,
  name,
  handleChange,
  keyPress,
  placeholder
}) => {
  const classes = useStyles();
  return (
    <StyledTableCell align="center">
      <div className={classes.percentContainer}>
        <input
          className={classes.input}
          name={name}
          placeholder={placeholder}
          type="number"
          value={value || ''}
          onChange={handleChange}
          onKeyPress={keyPress}
        />
        <span>%</span>
      </div>
    </StyledTableCell>
  );
};

export default InputControlled;
